import type { CardCarouselProps } from '@iheartjane/menu';
import { CardCarousel } from '@iheartjane/menu';
import { Button, Flex, Typography } from '@iheartjane/reefer';
import { clsx } from 'clsx';
import { useState } from 'react';

import { WEIGHT_TO_GRAMS } from '@jane/bloom/dataAccess/constants';
import { useStoreSwitcher } from '@jane/bloom/hooks/storeSwitcher/useStoreSwitcher';
import type { StoreCarryingProduct } from '@jane/bloom/viewModels/productDetail';

import styles from './otherLocationsRow.module.css';

export const OtherLocationsRow = ({
  locations,
  mode = 'ideal-width',
}: {
  locations: StoreCarryingProduct[];
  mode?: CardCarouselProps['mode'];
}) => {
  const [selectedStoreId, setSelectedStoreId] = useState<number | null>(null);

  const { setPinnedStore } = useStoreSwitcher();

  const updateStore = () => {
    if (selectedStoreId !== null) {
      setPinnedStore(selectedStoreId);
      setSelectedStoreId(null);
    }
  };

  return (
    <>
      <CardCarousel
        beforeHeader={
          <Typography variant="body-bold">
            Purchase from other locations
          </Typography>
        }
        cardWidth={300}
        cardWidthMobile={300}
        mode={mode}
        name="Purchase from other locations"
        className={styles['otherLocationsRow']}
      >
        {locations.map((location) => {
          return (
            <CardCarousel.Card key={location.store_id}>
              {/** @todo use elements with appropriate role */}
              {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */}
              <div
                className={clsx(styles['locationCard'], {
                  [styles['selectedLocationCard']]:
                    selectedStoreId === location.store_id,
                })}
                onClick={() => setSelectedStoreId(location.store_id)}
              >
                <Typography variant="body-bold" maxLines={1}>
                  {location.store_name}
                </Typography>
                <Typography maxLines={1}>{location.store_address}</Typography>
                {location.distance && (
                  <Typography>{`${location.distance} miles away`}</Typography>
                )}
                {location.available_weights.length > 0 && (
                  <Flex gap={4}>
                    <Typography variant="body-bold">Weights</Typography>
                    {location.available_weights
                      .map(
                        (weight: string) =>
                          `${String(WEIGHT_TO_GRAMS[weight])}g`
                      )
                      .map((weight) => (
                        <Typography
                          key={`${location.store_id}-${weight}`}
                          ml={4}
                        >
                          {weight}
                        </Typography>
                      ))}
                  </Flex>
                )}
              </div>
            </CardCarousel.Card>
          );
        })}
      </CardCarousel>
      <Button
        mt={16}
        full
        disabled={selectedStoreId === null}
        variant="primary"
        label="Update store"
        onClick={updateStore}
      />
    </>
  );
};
